import React from 'react';
import 'assets/scss/skeleton-ui.css'

const StockSkeletonChart = () => {
  return (
    <div className="skeleton-container line-skeleton">
      <div className="head-container p-4 d-flex flex-row justify-content-between">
        <div className="head-item col-4"></div>
        <div className="head-item col-2"></div>
      </div>
      <div className="row p-4 pr-5">
        <div className="col-2 chart-y">
          <div className="skeleton-item chart-y-item"></div>
          <div className="skeleton-item chart-y-item"></div>
          <div className="skeleton-item chart-y-item"></div>
          <div className="skeleton-item chart-y-item"></div>
          <div className="skeleton-item chart-y-item"></div>
          <div className="skeleton-item chart-y-item"></div>
        </div>
        <div className="col-10 d-flex flex-row justify-content-around">
          <div className="horizontal-lines">
            <hr />
            <hr />
            <hr />
            <hr />
            <hr />
            <hr />
          </div>
          <div className="skeleton-line-container">
            <div className="skeleton-line1">
              <div className="skeleton-line-each skeleton-line1a"></div>
              <div className="skeleton-line-each skeleton-line1b"></div>
              <div className="skeleton-line-each skeleton-line1c"></div>
              <div className="skeleton-line-each skeleton-line1d"></div>
              <div className="skeleton-line-each skeleton-line1e"></div>
              <div className="line-skeleton-ball skeleton-line1-balla"></div>
              <div className="line-skeleton-ball skeleton-line1-ballb"></div>
              <div className="line-skeleton-ball skeleton-line1-ballc"></div>
              <div className="line-skeleton-ball skeleton-line1-balld"></div>
              <div className="line-skeleton-ball skeleton-line1-balle"></div>
              <div className="line-skeleton-ball skeleton-line1-ballf"></div>
            </div>
            <div className="skeleton-line2">
              <div className="skeleton-line-each skeleton-line2a"></div>
              <div className="skeleton-line-each skeleton-line2b"></div>
              <div className="skeleton-line-each skeleton-line2c"></div>
              <div className="skeleton-line-each skeleton-line2d"></div>
              <div className="skeleton-line-each skeleton-line2e"></div>
              <div className="line-skeleton-ball skeleton-line2-balla"></div>
              <div className="line-skeleton-ball skeleton-line2-ballb"></div>
              <div className="line-skeleton-ball skeleton-line2-ballc"></div>
              <div className="line-skeleton-ball skeleton-line2-balld"></div>
              <div className="line-skeleton-ball skeleton-line2-balle"></div>
              <div className="line-skeleton-ball skeleton-line2-ballf"></div>
            </div>
          </div>
          <div className="bar-container ">
            <div className="bar-title"></div>
          </div>
          <div className="bar-container ">
            <div className="bar-title"></div>
          </div>
          <div className="bar-container ">
            <div className="bar-title"></div>
          </div>
          <div className="bar-container ">
            <div className="bar-title"></div>
          </div>
          <div className="bar-container ">
            <div className="bar-title"></div>
          </div>
          <div className="bar-container ">
            <div className="bar-title"></div>
          </div>
        </div>

      </div>
    </div>

  )
}

const ColumnSkeletonChart = () => {
  return (
    <div className="skeleton-container horizontal-bar-chart-skeleton">
      <div className="head-container p-4 d-flex flex-row justify-content-between">
        <div className="head-item col-4"></div>
        <div className="head-item col-2"></div>
      </div>
      <div className="row p-4 pr-5">
        <div className="col-2 chart-y">
          <div className="skeleton-item chart-y-item"></div>
          <div className="skeleton-item chart-y-item"></div>
          <div className="skeleton-item chart-y-item"></div>
          <div className="skeleton-item chart-y-item"></div>
        </div>
        <div className="col-10">
          <div className="vertical-lines">
            <div className="each-vr">
              <hr />
              <div className="bar-title"></div>
            </div>
            <div className="each-vr">
              <hr />
              <div className="bar-title"></div>
            </div>
            <div className="each-vr">
              <hr />
              <div className="bar-title"></div>
            </div>
            <div className="each-vr">
              <hr />
              <div className="bar-title"></div>
            </div>
            <div className="each-vr">
              <hr />
              <div className="bar-title"></div>
            </div>
            <div className="each-vr">
              <hr />
              <div className="bar-title"></div>
            </div>
          </div>
          <div className="horizontal-bar-container d-flex flex-column justify-content-around">
            <div className="bar-item" style={{ width: 50 }}></div>
            <div className="bar-item" style={{ width: 150 }}></div>
            <div className="bar-item" style={{ width: 100 }}></div>
            <div className="bar-item" style={{ width: 200 }}></div>
          </div>
        </div>
      </div>
    </div>

  )
}

const BarChartSkeleton = () => {
  return (
    <div className="skeleton-container">
      <div className="head-container p-4 d-flex flex-row justify-content-between">
        <div className="head-item col-4"></div>
        <div className="head-item col-2"></div>
      </div>
      <div className="row p-4 pr-5">
        <div className="col-2 chart-y">
          <div className="skeleton-item chart-y-item"></div>
          <div className="skeleton-item chart-y-item"></div>
          <div className="skeleton-item chart-y-item"></div>
          <div className="skeleton-item chart-y-item"></div>
          <div className="skeleton-item chart-y-item"></div>
          <div className="skeleton-item chart-y-item"></div>
        </div>
        <div className="col-10 d-flex flex-row justify-content-around">
          <div className="horizontal-lines">
            <hr />
            <hr />
            <hr />
            <hr />
            <hr />
            <hr />
          </div>
          <div className="bar-container ">
            <div className="bar-item" style={{ height: 150 }}></div>
            <div className="bar-title"></div>
          </div>
          <div className="bar-container ">
            <div className="bar-item" style={{ height: 200 }}></div>
            <div className="bar-title"></div>
          </div>
          <div className="bar-container ">
            <div className="bar-item" style={{ height: 115 }}></div>
            <div className="bar-title"></div>
          </div>
          <div className="bar-container ">
            <div className="bar-item" style={{ height: 225 }}></div>
            <div className="bar-title"></div>
          </div>
          <div className="bar-container ">
            <div className="bar-item" style={{ height: 150 }}></div>
            <div className="bar-title"></div>
          </div>
          <div className="bar-container ">
            <div className="bar-item" style={{ height: 95 }}></div>
            <div className="bar-title"></div>
          </div>
        </div>

      </div>
    </div>

  )
}

const ChartSkeleton = ({ chartType }) => {
  if (chartType == 'bar') {
    return <ColumnSkeletonChart />
  } else if (chartType == 'line') {
    return <StockSkeletonChart />
  }
  return <BarChartSkeleton />
};

export default ChartSkeleton;



// WEBPACK FOOTER //
// ./src/components/skeleton-uis/charts/ChartSkeleton.js